import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H4, Text, Table, Small, Button } from '@bigcommerce/big-design';
import { DeleteIcon } from '@bigcommerce/big-design-icons';

import LoadingSpinner from '../partials/LoadingSpinner';
import { deleteMetadata } from '../../redux/actions/products';

const InventoryDetailsModal = ({ payload, showInventoryDetailsModal, setShowInventoryDetailsModal, activeProductInventoryDetails, productId, variantId, deleteOrphanedMetadata }) => {
  const [deleted, setDeleted] = useState([]);

  const onHandItems = () => {
    let onHand = [];

    activeProductInventoryDetails.inventories.forEach((item) => {
      onHand.push({
        location: item.location_name,
        available: item.available_to_sell,
        stock: item.total_inventory_onhand
      })
    })

    return onHand;
  }

  const onOrderItems = () => {
    let onOrder = [];

    activeProductInventoryDetails.purchase_orders.forEach((item) => {
      onOrder.push({
        count: item.count,
        invoice_number: item.invoice_number,
        supplier_order_number: item.supplier_order_number,
        shipment_expected_at: item.shipment_expected_at,
        orphaned: item.orphaned,
        metafield_id: item.metafield_id
      })
    })

    return onOrder;
  }

  const deleteOrphan = (metafieldId) => {
    let newDeleted = [...deleted]
    newDeleted.push(metafieldId);
    setDeleted(newDeleted);
    deleteOrphanedMetadata(payload, productId, variantId, metafieldId);
  }


  return(
    <>
      <Modal
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Inventory Details"
          isOpen={showInventoryDetailsModal}
          onClose={() => setShowInventoryDetailsModal(false)}
        >
        { !activeProductInventoryDetails &&
          <LoadingSpinner statusText="Loading inventory details" />
        }

        { activeProductInventoryDetails &&
          <>
            <H4>On Hand</H4>
            <Table
              columns={[
                { header: 'Location', hash: 'location', render: ({ location }) => location },
                { header: 'Available', hash: 'available', render: ({ available }) => available },
                { header: 'On Hand', hash: 'stock', render: ({ stock }) => stock },
              ]}
              items={onHandItems()}
              stickyHeader
            />

            <hr />

            <H4>On Order</H4>
            <Table
              columns={[
                { header: 'Invoice #', hash: 'invoice_number', render: ({ invoice_number }) => invoice_number },
                { header: 'Purchase Order #', hash: 'supplier_order_number', render: ({ supplier_order_number }) => supplier_order_number },
                { header: 'Count', hash: 'count', render: ({ count }) => count },
                { header: 'Expected Date', hash: 'shipment_expected_at', render: ({ shipment_expected_at }) => shipment_expected_at.substring(0, 10) },
                {
                  header: 'Orphaned',
                  hash: 'orphaned',
                  tooltip: 'An error may have occurred while attempting to remove this purchase order line',
                  render: ({ orphaned, metafield_id }) => orphaned ? (
                    <>
                      { !(deleted.indexOf(metafield_id) >= 0) &&
                        <>
                          <Text color="danger">Orphaned</Text>
                          <Button 
                            actionType="destructive" 
                            iconOnly={<DeleteIcon title="delete" />} 
                            onClick={() => deleteOrphan(metafield_id)}
                          />
                        </>
                      }
                      { (deleted.indexOf(metafield_id) >= 0) &&
                        <Small>Removed</Small>
                      }
                    </>) : (<Small>-</Small>),
                }
              ]}
              items={onOrderItems()}
              stickyHeader
            />
          </>
        }
      </Modal>
    </>
  )
}

const mapStateToProps = state => ({
  activeProductInventoryDetails: state.products.activeProductInventoryDetails,
});

const mapDispatchToProps = (dispatch) => ({
  deleteOrphanedMetadata: (payload, productId, variantId, metafieldId) => dispatch(deleteMetadata(payload, productId, variantId, metafieldId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InventoryDetailsModal);
